import WrapperQuoteProcurementPartInfo from '@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo';
import { TextEllipsis } from '@/main/components/shared/styles';
import { GetItemsCancelledBySupplierResponse } from '@/main/models/response';
import { getTranslateByKey } from '@/main/services/utils';
import * as S from './styles';
interface IUnelegiblePartsConfirmation {
  parts: GetItemsCancelledBySupplierResponse[];
}

export function UnelegiblePartsConfirmation({
  parts
}: Readonly<IUnelegiblePartsConfirmation>) {
  return (
    <S.ConfirmationContainer>
      <S.ConfirmationTitle>
        <span>
          {getTranslateByKey('information.partsNotElegibile')}
        </span>
      </S.ConfirmationTitle>
      {parts.map(p => (
        <S.ConfirmationMessage key={p.procurementSupplierItemGuid}>
          <S.Label>{getTranslateByKey('information.claim')}:</S.Label>
          <S.Value>{p.claimNumber}</S.Value>
          <S.Separator>-</S.Separator>
          <S.Label>{getTranslateByKey('information.quote')}:</S.Label>
          <S.Value>{p.quoteCode}</S.Value>
          <S.Separator>-</S.Separator>
          <S.Label>{getTranslateByKey('information.order')}:</S.Label>
          <S.Value>{p.procurementCode}</S.Value>
          <S.Separator>-</S.Separator>
          <S.PartWrapper>
            <TextEllipsis className='part-wrapper-ellipsis'>
              <WrapperQuoteProcurementPartInfo
                data={p.quoteProcurementPartInfo}
                renderType="row"
                isEllipsisText
                isTooltip
              />
            </TextEllipsis>
          </S.PartWrapper>
        </S.ConfirmationMessage>
      ))}
    </S.ConfirmationContainer>
  );
}
